interface IProp {
  className?: string
}

const NoBeeding = (props:IProp) => {
  const { className = 'fill-none stroke-black' } = props
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3402 7.07848C12.717 6.46678 11.8388 6.33996 10.3075 6.3941H4.70163C4.59356 6.3941 4.48547 6.40156 4.37867 6.41815C3.15889 6.6076 2.59703 6.85934 2.33948 7.33854C2.13377 7.7213 2.26165 8.18339 2.45226 8.57389L5.25194 14.3093C5.37821 14.5679 5.55153 14.8032 5.77223 14.9879C7.501 16.4354 8.60177 16.3425 10.3236 15.0086C10.5793 14.8105 10.779 14.55 10.9195 14.2586L13.4759 8.95709C13.775 8.33699 13.8315 7.56071 13.3402 7.07848Z"
        className={className}
        strokeWidth="0.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.95751 0C5.79946 0 4.02344 1.74944 4.02344 3.90749V6.69856C4.02344 6.8894 4.17815 7.04412 4.369 7.04412H11.546C11.7369 7.04412 11.8916 6.8894 11.8916 6.69856V3.90749C11.8916 1.74944 10.1156 0 7.95751 0ZM7.93093 5.36948C8.73836 5.36948 9.39292 4.71492 9.39292 3.90749C9.39292 3.10006 8.73836 2.4455 7.93093 2.4455C7.1235 2.4455 6.46894 3.10006 6.46894 3.90749C6.46894 4.71492 7.1235 5.36948 7.93093 5.36948Z"
        className={className}
      />
    </svg>
  )
}

export default NoBeeding
